/**
 *      Toggles Quick View of an Employee
 */
function toggleEmployeeQuickView(event) {
    if (dragging) return;

    var target = event.target.closest(".toggle-quickview, .close-quickview");
    if (target) {
        event.preventDefault();
        event.stopPropagation();

        if (target.classList.contains("quickview-active") || target.classList.contains("close-quickview")) {
            // Close open quickview and move to end
            closeEmployeeQuickview();

        } else {
            // Remove old quickview and move to end
            closeEmployeeQuickview();

            // Open new quickview and move to correct location
            openEmployeeQuickView(target);
        }
    }
}

function openEmployeeQuickView(element) {
    element.classList.add("quickview-active");
    document.querySelector("#" + element.parentElement.parentElement.getAttribute('id') + " .quickview").innerHTML = element.nextElementSibling.innerHTML;
    element.nextElementSibling.innerHTML = ''; // Remove from original location so lightbox doesn't double its slides
    moveQuickView(element);
}

function moveQuickView(element) {
    var target = document.querySelector(".toggle-quickview.quickview-active").parentElement;

    if (target) {
        var currentPlacement = Array.prototype.indexOf.call(document.querySelector("#" + element.parentElement.parentElement.getAttribute('id')).children, target) + 1;

        /**
         *  NOTICE !!!
         *  These must match the breakpoints defined in src/scss/templates/_page-listingEmployees.scss
         *  in order for the quickview to be located correctly
         **/
        if (window.widthREMs < 36) {
            // 1 column, can be moved directly after
            target.insertAdjacentElement("afterend", document.querySelector("#" + element.parentElement.parentElement.getAttribute('id') + " .quickview"));

        } else
        if (window.widthREMs < 54) {
            // 2 columns, move to start of next row
            var insertAfter = (Math.ceil(currentPlacement / 2) * 2) - 1;
            if(insertAfter > document.querySelector("#" + element.parentElement.parentElement.getAttribute('id')).children.length - 1) var insertAfter = document.querySelector("#" + element.parentElement.parentElement.getAttribute('id')).children.length - 1;
            document.querySelector("#" + element.parentElement.parentElement.getAttribute('id')).children[insertAfter].insertAdjacentElement("afterend", document.querySelector("#" + element.parentElement.parentElement.getAttribute('id') + " .quickview"));

        } else
        if (window.widthREMs < 72) {
            // 3 columns, move to start of next row
            var insertAfter = (Math.ceil(currentPlacement / 3) * 3) - 1;
            if(insertAfter > document.querySelector("#" + element.parentElement.parentElement.getAttribute('id')).children.length - 1) var insertAfter = document.querySelector("#" + element.parentElement.parentElement.getAttribute('id')).children.length - 1;
            document.querySelector("#" + element.parentElement.parentElement.getAttribute('id')).children[insertAfter].insertAdjacentElement("afterend", document.querySelector("#" + element.parentElement.parentElement.getAttribute('id') + " .quickview"));

        } else {
            // 4 columns, move to start of next row
            var insertAfter = (Math.ceil(currentPlacement / 4) * 4) - 1;
            if(insertAfter > document.querySelector("#" + element.parentElement.parentElement.getAttribute('id')).children.length - 1) var insertAfter = document.querySelector("#" + element.parentElement.parentElement.getAttribute('id')).children.length - 1;
            document.querySelector("#" + element.parentElement.parentElement.getAttribute('id')).children[insertAfter].insertAdjacentElement("afterend", document.querySelector("#" + element.parentElement.parentElement.getAttribute('id') + " .quickview"));

        }
    }
}

function closeEmployeeQuickview() {
    var element = document.querySelector(".toggle-quickview.quickview-active");

    // Close any open quickviews
    if (element) {
        document.querySelector(".toggle-quickview.quickview-active + .quickview-wrapper").innerHTML = element.parentElement.parentElement.querySelector(".quickview").innerHTML; // Move quickview contents back to original location
        element.classList.remove("quickview-active");

        // Move quickview back to end
        if (element.parentElement.parentElement.querySelector(".quickview")) {
            element.parentElement.parentElement.querySelector(".quickview").innerHTML = '';
            element.parentElement.parentElement.appendChild(element.parentElement.parentElement.querySelector(".quickview"));
        }
    }
}

document.addEventListener("click", toggleEmployeeQuickView);
document.addEventListener("touchend", toggleEmployeeQuickView);

window.addEventListener("orientationchange", closeEmployeeQuickview);
window.addEventListener("resize", closeEmployeeQuickview);